// from http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
export default function escapeRegExp(str: string): string {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
